import { render, staticRenderFns } from "./LCTR.vue?vue&type=template&id=2d083244&"
import script from "./LCTR.vue?vue&type=script&lang=js&"
export * from "./LCTR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports